<template>
  <div class="_content">
    <div class="invoice-info">
      <van-field
        v-for="item in invoiceInfo"
        readonly
        clickable
        :label="item.label"
        :key = item
        :value="item.value"
        :placeholder="item.value"
      />
      <!-- 联系市场经理 -->
      <div class="invoice-call">
        <div>
          <span>如有疑问，</span
          ><span  v-call="{tel:'15561531212'}" class="invoice-call-blue"
            >联系市场经理</span
          >
        </div>
      </div>
    </div>
    <div
      class="invoice-copy-btn"
      v-clipboard:copy="copyContent"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
    >
      <span>一键复制开票信息</span>
    </div>
  </div>
</template>
<script>
import util from "@/commons/util";
import config from "@/configs/config";
export default {
  components: {},
  data() {
    return {
      copyContent: ``,
      invoiceInfo: {
        invoiceTitle: {
          label: "发票抬头：",
          value: ""
        },
        invoiceTaxNumber: {
          label: "纳税识别号：",
          value: ""
        },
        invoiceType: {
          label: "开票类型：",
          value: ""
        },
        invoiceSubject: {
          label: "开票科目：",
          value: ""
        },
        invoicePoint: {
          label: "开票税点：",
          value: ""
        },
        invoiceBankAccount: {
          label: "银行账户：",
          value: ""
        },
        invoiceBankName: {
          label: "开户银行：",
          value: ""
        },
        invoiceAddress: {
          label: "联系地址：",
          value: ""
        },
        invoicePhone: {
          label: "联系方式：",
          value: ""
        }
      }
    };
  },
  created() {
    this.init();
  },
  computed: {
    shopId() {
      return tuhu.store.state.userInfo.shopId;
    }
  },
  methods: {
    onCopy(e) {
      tuhu.toast("复制成功");
    },
    onError() {
      tuhu.toast("复制失败");
    },
    async init() {
      let formdata = new FormData();
      formdata.append("shopId", parseInt(this.shopId)); // 文件对象
      let res = await tuhu.fetch(`${config.apis.INVOICE_INFO}?shopId=${parseInt(this.shopId)}`);
      if (res && res.code === "200") {
        Object.keys(this.invoiceInfo).forEach(key => {
          if (res.data.hasOwnProperty(key)) {
            this.invoiceInfo[key].value = res.data[key];
          }
        });
        const data = res.data;
        console.log(data.invoiceTitle)
        this.copyContent = `发票抬头：${data.invoiceTitle}
纳税识别号：${data.invoiceTaxNumber}
开票类型：${data.invoiceType}
开票科目：${data.invoiceSubject}
开票税点：${data.invoicePoint}
银行账户：${data.invoiceBankAccount}
开户银行：${data.invoiceBankName}
联系地址：${data.invoiceAddress}
联系方式：${data.invoicePhone}`;
      } else {
        tuhu.toast(res.message || "网络错误");
      }
    }
  }
};
</script>
<style lang="less" scoped>
._content {
  background-color: #f8f9fb;
  .confirm-call {
    width: 15.55rem;
    height: 8.1rem;
    background: #ffffff;
    border-radius: 0.6rem;
    .title {
      margin-top: 0.75rem;
      width: 15.55rem;
      height: 1.3rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 0.9rem;
      color: rgba(0, 0, 0, 0.9);
      line-height: 1.3rem;
      text-align: center;
      font-style: normal;
    }
    .text {
      margin: 0.8rem 0 1.25rem 0;
      width: 15.55rem;
      height: 1.2rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.8rem;
      color: rgba(0, 0, 0, 0.6);
      line-height: 1.2rem;
      text-align: center;
      font-style: normal;
    }
    .btn {
      border-top: 0.03rem #e7e7e7 solid;
      display: flex;
      flex-direction: row;
      height: 2.8rem;
      .btn-left {
        border-right: 0.03rem #e7e7e7 solid;
        width: 7.13rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 0.8rem;
        color: rgba(0, 0, 0, 0.9);
        line-height: 2.8rem;
        text-align: center;
        font-style: normal;
      }
      .btn-right {
        width: 7.13rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 0.8rem;
        color: #266cea;
        line-height: 2.8rem;
        text-align: center;
        font-style: normal;
      }
    }
  }
  .invoice-info {
    margin: 0.75rem;
    padding: 1rem 0.75rem;
    border-radius: 24px;
    background-color: #ffffff;
    .invoice-call {
      height: 0.7rem;
      width: 100%;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.6rem;
      color: #333333;
      line-height: 0.6rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-style: normal;
      .invoice-call-blue {
        display: inline-block;
        padding: 0.1rem;
        color: #266cea;
        border-bottom: 0.03rem solid #266cea;
      }
    }
  }
  .invoice-copy-btn {
    margin: 1.5rem 3.38rem;
    width: 12rem;
    height: 2.35rem;
    background: #266cea;
    border-radius: 1.18rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.65rem;
      color: #ffffff;
      line-height: 0.65rem;
      text-align: left;
      font-style: normal;
    }
  }
  /deep/.van-cell {
    padding: 0;
    margin: 0 0 1.25rem 0;
    background-color: transparent;
  }
  /deep/.van-cell::after {
    border: none;
  }
  /deep/.van-cell__title.van-field__label {
    width: 3.6rem;
    height: 0.85rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.6rem;
    color: #333333;
    line-height: 0.6rem;
    text-align: left;
  }
  /deep/.van-field__control {
    height: 1.05rem;
    padding-left: 0.25rem;
    padding-bottom: 0.25rem;
    border-bottom: 0.03rem solid #e5e5e5;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.6rem;
    color: #666666;
    line-height: 0.6rem;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/index.vue